import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ZxcvbnResult, debounce } from '@zxcvbn-ts/core';
import { ZxcvbnService } from 'src/app/services/zxcvbn/zxcvbn.service';

@Component({
  selector: 'app-zxcvbn-password-strength',
  standalone: false,
  templateUrl: './zxcvbn-password-strength.component.html',
  styleUrl: './zxcvbn-password-strength.component.scss'
})
export class ZxcvbnPasswordStrengthComponent implements OnChanges {
  
  @Input() password = '';
  @Input() control: NgModel | null = null;
  result: ZxcvbnResult | null = null;

  constructor(
    private zxcvbnService: ZxcvbnService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['password']) {
      this.debouncedCheck(changes['password'].currentValue);
    }
  }

  get color(): 'warn' | 'accent' | 'primary' {
    const score = this.result?.score ?? 0;
    if (score <= 1) return 'warn';
    if (score === 2) return 'accent';
    return 'primary';
  }

  get label(): string {
    return ['Very weak', 'Weak', 'Fair', 'Strong', 'Very strong'][this.result?.score ?? 0];
  }

  private debouncedCheck = debounce(async (value: string) => {
    this.result = value ? await this.zxcvbnService.check(value) : null;
    this.control?.control?.updateValueAndValidity();
  }, 200);

}
